import React, { useEffect, useCallback, useState } from 'react';
import { axiosAjax } from '@app/src/config/axios';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { Field, reduxForm, change } from 'redux-form';
import { Title } from '@app/src/common/Title';
import { TabProfile } from '@app/src/views/StepPayment/formPayment';
import {
  TermsAndConditions,
  LinkTermsAndConditions,
  FormWrapper
} from './styled';
import { renderCheckbox } from '@app/src/common/Checkbox';
import { Disclaimer } from '@app/src/common/Disclaimer';
import * as validate from '@app/src/utils/validations';
import { ModalErrorFeature } from '@app/src/common/modalError';
import { CATEGORIES } from '@app/src/config/categories';
import {
  fetchPrice,
  sendDataPayment,
  setDataPaymentConfirm,
  createDniData,
  updateDniData,
  createRucData,
  updateRucData
} from '@app/src/views/StepPayment/formPayment';
import { isClientEnv } from '@app/src/utils/validations';
import { actionsModalError } from '@app/src/common/modalError';
import { FormActions } from '@app/src/views/StepPayment/formPayment/components/FormActions';
import { ModalProcessPayment } from '@app/src/views/StepPayment/formPayment/components/ModalProcessPayment';
import { setPrintGeneral } from '@app/src/views/StepTwo/channelPublication';
import { actionsFlashMessageError } from '@app/src/common/flashMessageError';

const isClient = isClientEnv();
const STATE_PAYMENT = {
  SUCESS: 'approved',
  PENDING: 'pending',
  DENIED: 'denied',
  FAILURED: 'failed'
};

interface Props {
  handleSubmit?: Function;
  reset?: Function;
  touch?: Function;
  untouch?: Function;
  clearSubmitErrors?: Function;
}

const Form: React.FC<Props> = ({ handleSubmit, untouch }) => {
  const history = useHistory();
  const location = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const priceTotal = useSelector(state => state.price.data.total);
  const isLoading = useSelector(state => state.price.isFetching);
  const error = useSelector(state => state.price.error);
  const currentDocumentType = useSelector(state => state.form.stepPayment.values.documentType);
  const currentTerms = useSelector(state => state.form.stepPayment.values.termsAndConditions);
  const currentPhone = useSelector(state => state.form.stepPayment.values.phone);
  const currentEmail = useSelector(state => state.form.stepPayment.values.email);
  const currentBusinessPhone = useSelector(state => state.form.stepPayment.values.businessPhone);
  const currentBusinessEmail = useSelector(state => state.form.stepPayment.values.businessEmail);
  const currentBusinessName = useSelector(state => state.form.stepPayment.values.businessName);
  const currentBusinessFatherLastName = useSelector(state => state.form.stepPayment.values.businessFatherLastName);
  const currentBusinessMotherLastName = useSelector(state => state.form.stepPayment.values.businessMotherLastName);
  const dniData = useSelector(state => state.dni.data);
  const rucData = useSelector(state => state.ruc.data);
  const isLoadingDniCreate = useSelector(state => state.dni.isFetchingCreate);
  const isLoadingDniUpdate = useSelector(state => state.dni.isFetchingUpdate);  const isLoadingRucCreate = useSelector(state => state.ruc.isFetchingCreate);
  const isLoadingRucUpdate = useSelector(state => state.ruc.isFetchingUpdate);
  const isLoadingPayment = useSelector(state => state.payment.isFetching);
  const currentPrice = useSelector(state => state.price.data.total);
  const print = isClient && JSON.parse(sessionStorage.getItem('print'));
  const getAliasCategory = () => location.pathname.split('-')[2];
  const categoryTheme = CATEGORIES[getAliasCategory()];
  const [ isShowModal, setIsShowModal ] = useState(false);
  const statusPayment = useSelector(state => state.payment.confirm.status);
  const category = categoryTheme.id;

  useEffect(() => {
    if (isClient && print && print.general && categoryTheme && print.general.category === categoryTheme.id) {
      dispatch(setPrintGeneral(print.general));
      let head = document.getElementsByTagName('head')[0];
      head.insertBefore(createCulqiScript(), head.firstChild);
      dispatch(fetchPrice(categoryTheme.id, id));
      return () => {
        head.removeChild(head.childNodes[0]);
      }
    } else {
      history.push(`${categoryTheme.link}-3/${id ? id : ''}`);
    }
  }, []);

  useEffect(() => {
    (window as any).culqi = async() => {
      try {

        if ((window as any).Culqi && (window as any).Culqi.error) {
          alert((window as any).Culqi.error.user_message);
          return;
        }

        let sendData = {};
        if ((window as any).Culqi.token) {
          sendData = {
            'token': (window as any).Culqi.token.id
          };
        }

        setIsShowModal(true);
        (window as any).Culqi.close();

        const { data } = await axiosAjax.put(
          process.env.API_PAYMENT_TRANSACTION
            .replace(':transactionId', '' + (window as any).transaction.id),
          JSON.stringify(sendData)
        );

        if (data && data.error) {
          dispatch(actionsModalError.openModalError());
          throw new Error();
        }

        if (data.data && data.data[0]) {
          const response = data.data[0];
          if (response.status === STATE_PAYMENT.FAILURED) {
            dispatch(actionsFlashMessageError.openFlashMessage());
          }
          if (response.status === STATE_PAYMENT.DENIED) {
            setIsShowModal(false);
            dispatch(actionsFlashMessageError.openFlashMessage());
          }
          if (response.status === STATE_PAYMENT.SUCESS|| response.status === STATE_PAYMENT.PENDING) {
            dispatch(setDataPaymentConfirm({
              order: response.transactionId,
              date: response.paymentDate || response.expireDate,
              price: response.total,
              cip: response.cip,
              status: response.status
            }));
          }
        } else {
          console.log('error');
          throw new Error();
        }
      } catch (e) {
        console.log('catch error');
        dispatch(actionsModalError.openModalError());
        throw new Error(e);
      }
    };
  }, [currentPrice]);

  useEffect(() => {
    if (isClient && statusPayment) {
      sessionStorage.setItem('print', JSON.stringify({ general : { category }}));
      if (statusPayment === 'approved') {
        history.push('/confirmacion-de-pago');
      }
      if (statusPayment === 'pending') {
        history.push('/pendiente-de-pago');
      }
    }
  }, [statusPayment]);

  const createCulqiScript = () => {
    if (isClient) {
      let script = document.createElement('script');
      script.setAttribute('src', 'https://checkout.culqi.com/js/v3');
      script.setAttribute('id', 'srcCulqi');
      return script;
    }
  };

  const handleClickSubmit = (data): void => {
    pushDatalayer(categoryTheme.name, data);
    let profileData = dniData;
    if (currentDocumentType === 'RUC') {
      profileData = rucData;
    }
    if (Object.keys(profileData).length === 0) {
      if (currentDocumentType === 'DNI') {
        dispatch(createDniData(data, category, id, priceTotal));
        return;
      }
      if (currentDocumentType === 'RUC') {
        dispatch(createRucData(data, category, id, priceTotal));
        return;
      }
    } else {
      if (currentDocumentType === 'DNI' && isChangeInputsTicketContact(profileData)) {
        dispatch(updateDniData(data, profileData.documentNumber, category, id, priceTotal));
        return;
      }
      if (currentDocumentType === 'RUC' && isChangeInputsBillContact(profileData)) {
        dispatch(updateRucData(data, profileData.documentNumber, category, id, priceTotal));
        return;
      }
      dispatch(sendDataPayment({
        customer: profileData && profileData.id,
        printDetail: id,
        category
      }, priceTotal));
    }
  }

  const getProfileType = (value: string): void => {
    dispatch(change('stepPayment', 'documentType', value));
  };

  const handleChangeCheckbox = (value: boolean): void => {
    dispatch(change('stepPayment', 'termsAndConditions', value));
  };

  const isChangeInputsTicketContact = (profileData) => currentPhone !== profileData.phone || currentEmail !== profileData.email;

  const isChangeInputsBillContact = (profileData): boolean => currentBusinessPhone !== profileData.phone || currentBusinessEmail !== profileData.email || currentBusinessName !== profileData.name || currentBusinessMotherLastName !== profileData.motherLastName || currentBusinessFatherLastName !== profileData.fatherLastName;

  const pushDatalayer = (categoryName: string, data) => {
    const document = data.documentType;
    let ticket = 'Boleta';
    let phone = data.phone;
    let email = data.email;
    if (document === 'RUC') {
      ticket = 'Factura';
      phone = data.businessPhone;
      email = data.businessEmail;
    }
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': 'Posting',
        'eventAction': `Paso 4 - ${categoryName}`,
        'eventLabel': `${ticket}|${phone}|${email}`,
        'eventValue': 1
      })
    }
  };

  const setTextButtonNext = useCallback((): string => (isLoading || error) ? 'cargando...' : `Pagar S/ ${priceTotal}`, [isLoading, error]);

  const setDisabledButtonNext = (): boolean => isLoading || isLoadingDniCreate || isLoadingDniUpdate || isLoadingPayment || isLoadingRucCreate || isLoadingRucUpdate;

  return(
  <React.Fragment>
    <ModalErrorFeature />
    <FormWrapper onSubmit={handleSubmit(handleClickSubmit)}>
      <Title>Tipo de comprobante</Title>
      <TabProfile
        handleChangeAction={untouch}
        getProfileType={getProfileType}
        color={categoryTheme.color} />
      <Field
        name="termsAndConditions"
        component={renderCheckbox}
        checked={currentTerms}
        handleChange={handleChangeCheckbox}
        validate={[validate.required]}
        colorActive={categoryTheme.color}
      >
        <TermsAndConditions>
            Acepto los <LinkTermsAndConditions target="_blank" color={categoryTheme.color} href="https://centraldeayuda.clasificados.pe/hc/es/articles/360040280151-T%C3%A9rminos-y-Condiciones">Términos y Condiciones</LinkTermsAndConditions> de Clasificados.pe
        </TermsAndConditions>
      </Field>
      <Disclaimer />
      <FormActions
        categoryConfig={categoryTheme}
        disabledButtonNext={setDisabledButtonNext()}
        textButtonNext={setTextButtonNext()}
      />
    <ModalProcessPayment isDisplay={isShowModal} />
    </FormWrapper>
  </React.Fragment>
)};

const FormHoc = reduxForm({
  form: 'stepPayment',
  initialValues: {
    dni: '',
    name: '',
    fatherLastName: '',
    motherLastName: '',
    email: '',
    phone: '',
    ruc: '',
    rznSocial: '',
    businessName: '',
    businessFatherLastName: '',
    businessMotherLastName: '',
    businessAddress: '',
    businessPhone: '',
    businessEmail: '',
    districtId: '',
    departmentId: '',
    documentType: 'DNI'
  }
})(Form);

export { FormHoc as FormPayment };
